export const AUTH_SERVICE_API_URL = '../auth/api';
export const APP_USERS_SERVICE_API_URL = '../app/api/users';
export const APP_ADMIN_SERVICE_API_URL = '../app/api/admin';
export const INGESTION_SERVICE_API_URL = '../ingestion/api';